import { createContext } from "react";

export interface UserContextType {
  username: string;
  setUsername: (value: string) => void;
}


export const UserContext = createContext<UserContextType>({
  username: "",
  setUsername: () => {},
});